import {theme} from '../theme';
import {useWindowInnerWidth} from './shared/hooks/useWindowInnerWidth';

export function useIsResponsiveTablet() {
  const innerWidth = useWindowInnerWidth();
  const isGreaterThanTablet =
    innerWidth >= Number(theme.screens.tablet.replace('px', ''));
  return isGreaterThanTablet;
}
